import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  Container: {
    marginLeft: '25px',
  },
  Date: {
    display: 'grid',
  },
  DateLabel: {
    marginBottom: '5px',
  },
  Wide: {
    width: '100%',
  },
  Bold: {
    fontWeight: 'bold',
  },
  Required: {
    '&:after': {
      content: '" *"',
      color: 'red',
    },
  },
  UpperCase: {
    textTransform: 'uppercase',
  },
  EndAdornmentRoot: {
    marginLeft: 0,
  },
  EndAdornmentIcon: {
    fontSize: 16,
  },
  SelectIconWithEndAdornment: {
    right: 30,
  },
  SuccessIcon: {
    color: 'green',
  },
  ErrorIcon: {
    color: 'red',
  },
});
